// note this is the laravel bootstrap for axios etc. NOT bootstrap framework.
require("./bootstrap");
require('@popperjs/core');

import * as bootstrap from "bootstrap";
var Tooltip = bootstrap.Tooltip;
var Popover = bootstrap.Popover;

// require('../../vendor/bastinald/laravel-livewire-toasts/resources/js/toasts');
require('./modals');

import '../../vendor/masmerise/livewire-toaster/resources/js';

var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'))
var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
  return new Popover(popoverTriggerEl, {container: 'body'});
})

var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
  return new Tooltip(tooltipTriggerEl)
})


const profileSelectEl = document.getElementById("profile-select");
if (profileSelectEl)
{
  const profileSelectChoice = new Choices(profileSelectEl, {
    classNames: {
      containerOuter: "choices profile-select",
    },
    callbackOnCreateTemplates: function(template) {
      return {
        item: (classNames, data) => {
          return template(`
            <div class="${classNames.item} ${
            data.highlighted
              ? classNames.highlightedState
              : classNames.itemSelectable
          } ${
            data.placeholder ? classNames.placeholder : ''
          }" data-item data-id="${data.id}" data-value="${data.value}" ${
            data.active ? 'aria-selected="true"' : ''
          } ${data.disabled ? 'aria-disabled="true"' : ''}>
              ${data.label}
            </div>
          `);
        },
        choice: (classNames, data) => {

          let custom = null;
          if (typeof data.customProperties === 'string' || data.customProperties instanceof String)
          {
            custom = JSON.parse(data.customProperties);
          }
          let customBadge = ``;
          if (custom && 'enabled' in custom)
          {
            customBadge = `<span class="badge me-1 ${custom.enabled ? 'bg-green' : 'bg-red'}"></span>`;
          }
          return template(`
            <div class="${classNames.item} ${classNames.itemChoice} ${
            data.disabled ? classNames.itemDisabled : classNames.itemSelectable
          }" data-select-text="${this.config.itemSelectText}" data-choice ${
            data.disabled
              ? 'data-choice-disabled aria-disabled="true"'
              : 'data-choice-selectable'
          } data-id="${data.id}" data-value="${data.value}" ${
            data.groupId > 0 ? 'role="treeitem"' : 'role="option"'
          }>
              ${customBadge} ${data.label}
            </div>
          `);
        },
      };
    },
  });

  profileSelectChoice.passedElement.element.addEventListener("choice", (e) => {
    if (e.detail.choice.value === "new")
    {
      window.location = "/dashboard/profile/create";
    }else{
      window.location = "/dashboard/profile/switch/" + parseInt(e.detail.choice.value);
    }
  });
}
